// Get filtered restaurants

function printToppingPortion(thePortion) {
    if (thePortion == "H1") {
        return " (first half only), ";
    }
    else if (thePortion == "H2") {
        return " (second half only), ";
    }
    else {
        return  ", ";
    }
}

export default (cartItem, special, index) => {
    let toppingDetails = "";

    if (special.items[index] && special.items[index].choices) {
        special.items[index].choices.forEach((theSpecialItem) => {
            if (theSpecialItem.id == cartItem.items[index].choice_id) {

                cartItem.items[index].toppings.forEach((theCartTopping) => {
                    theSpecialItem.toppings.forEach((theTopping) => {
                        if (theTopping.id == theCartTopping.id) {
            
                            if (theCartTopping.isdefault && theCartTopping.amount == "extra") {
                                toppingDetails += "Extra "+theTopping.name+printToppingPortion(theCartTopping.portion);
                            }
                            else if (theCartTopping.isdefault && theCartTopping.amount == "none") {
                                toppingDetails += "No "+theTopping.name+printToppingPortion(theCartTopping.portion);
                            }
                            else if (theCartTopping.isdefault && theCartTopping.portion != "W") {
                                toppingDetails += "Include "+theTopping.name+printToppingPortion(theCartTopping.portion);
                            }
                            else if (theCartTopping.isdefault) {
                                toppingDetails += theTopping.name+printToppingPortion(theCartTopping.portion);
                            }
                            else if (!theCartTopping.isdefault && theCartTopping.amount == "include") {
                                toppingDetails += "Add "+theTopping.name+printToppingPortion(theCartTopping.portion);   
                            }
                        }
                    });
                });
            }
        });
    }

    toppingDetails = toppingDetails.replace(/, $/, '');

    if (toppingDetails == "") {
        return "None.";
    }

    return toppingDetails;
};